import React from 'react'
import { CardImage, ChevronDown, Link } from 'chemistry'
import classNames from 'classnames'

export const createData = item => (item.type === 'product' ? { productId: item.id } : { category: item })

const ItemsBuyList = ({ items = [], isActive, title, onOpenCategory, type, prop }) => {
  return (
    <div
      className={classNames('buy-list-items flex-column gap-16', {
        'buy-list-items-hide-inactive': !isActive
      })}
    >
      <div className='flex gap-16'>
        <h3>{title}</h3>
        <span className='flex items-center justify-center'>{items.length}</span>
      </div>
      {items?.map(item => {
        if (!item.title || !item.image) return null
        return (
          <div
            key={item.id}
            className='buy-list-suggestion-item flex items-center gap-half gap-6 ml-auto'
            onClick={() => onOpenCategory(createData(item))}
            itemProp={prop}
            itemType={`https://schema.org/${type}`}
            itemScope
          >
            <div className='print-checkbox show-print' />
            <CardImage alt={item.title} source={item.image} title={item.title} />
            <p itemProp='name'>{item.title}</p>
            <div className='flex justify-end gap-12 ml-auto items-center'>
              {item.type === 'product' && !!item.amount && <span>{item.amount}x</span>}
              <Link variant='primary' className='flex items-center justify-center'>
                <ChevronDown color='white' />
              </Link>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ItemsBuyList
